// tslint:disable: no-unused-expression
import { Pipe, PipeTransform } from '@angular/core';

import { GetBooleanResultPipe } from './get-boolean-result.pipe';

import { HSCStructure, HighlightStructure, HSCase } from '../interfaces/datatable';
import { LocalStringToNumberPipe } from './local-string-to-number.pipe';
import { AnyValues } from '../interfaces/undetermined';

@Pipe({ name: 'setFill' })
export class SetFillPipe implements PipeTransform {

  /** En caso de modificar el pipe también se debe modifica la función en el back Model/common/ajx_build_reports -> setFill */

  /* transform(): Pipe que devuelve una clase a la columna de una fila de acuerdo a una estructura de condiciones definida
    value: Estructura de condiciones
    row: Fila de la tabla
    index: Columna de a fila a evaluar
  */
  transform(value: HSCStructure, row: (AnyValues | string[]), index: number | string): string {
    // ↓ Obtiene el valor del campo de la fila actual y columna recibida y lo formatea
    const fieldValue = value.format ? (row[index] ? new LocalStringToNumberPipe().transform(row[index], value.format) : row[index]) : row[index];
    // ↓ Clases a retornar;
    let classes = '';
    // ↓ Verifica que haya condiciones
    if ('conditions' in value) {
      // ↓ Itera las condiciones
      value.conditions.forEach((elm: HighlightStructure) => {
        // operators: Expresiones (&& y ||) a usar cuando hay más de 1 condición
        const [operators, results]: [string[], boolean[]] = [[], []];
        // results: Resultados de la evaluación de los valores
        // ↓ Itera las condiciones por opción
        elm.cases.forEach((el: HSCase) => {
          // ↓ Verifica si se hay más de 1 condición y asigna la expresión que se utilizará
          if (el.next) { operators.push(el.next); }
          // a: Valor izquierdo a evaluar, b: valor derecho a evaluar
          let [a, b]: any[] = [null, null];
          // ↓ Asigna el valor izquierdo
          a = el.hasOwnProperty("value") ? (!el.hasOwnProperty("index") ? fieldValue : el.value) : fieldValue;
          // ↓ Asigna el valor derecho
          b = el.hasOwnProperty("index") ? (el.format ? new LocalStringToNumberPipe().transform(row[el.index], el.format) : row[el.index]) : el.value;
          // ↓ Asigna el resultado de la comparación
          results.push(new GetBooleanResultPipe().transform(a, b, el.operator, el.cast ? el.cast : null));
        });
        let result: boolean | number = false;
        switch (elm.type) {
          // ↓ Caso cuando se debe debe obtener la clase de acuerdo a el resultado de todas las condiciones
          case "reduce":
            // ↓ Obtiene el resultado de las condiciones por opción
            result = results.reduce((pre: boolean, cur: boolean, idx: number) => new GetBooleanResultPipe().transform(pre, cur, operators[idx - 1], "bool"));
            break;
          // ↓ Caso cuando se debe debe obtener la clase de acuerdo al primer resultado verdadero
          case "index": result = results.findIndex((el: boolean) => el); break;
          // ↑ Devuelve el índice del primer resultado verdadero
        }
        // ↓ Asigna la clase requerida
        classes += (" " + (elm.options.hasOwnProperty(`${result}`) ? elm.options[`${result}`] : ''));
      });
    }
    // ↓ Devuelve las clases
    return classes;
  }

}
